import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
  selector: 'sf-g2-love-banner',
  templateUrl: './g2-love-banner.component.html',
  styleUrl: './g2-love-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class G2LoveBannerComponent {

}
